<template>
  <div>
    <table-list
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange">
      <template #action={row}>
        <el-button class="tableBtn" @click="viewOrHandle(row)" type="text" size="small">详情</el-button>
      </template>
    </table-list>
    <!-- 编辑 -->
    <div class="dialogDiv">
      <el-dialog title="编辑房屋" :visible.sync="dialogFormVisible" :before-close="closeData" center>
        <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="室号" prop="roomName" class="formItem">
                <el-input v-model="addForm.roomName" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属园区" prop="parkCode" class="formItem">
                <!-- <el-input v-model="addForm.parkLevel" clearable placeholder="请输入"></el-input> -->
                <el-select v-model="addForm.parkCode" placeholder="请选择" style="width:100%" @change="handleAddParkCode">
                  <el-option v-for="item in basePackInfoList" :key="item.parkCode" :label="item.parkName"
                    :value="item.parkCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属楼宇" prop="buildingId" class="formItem">
                <el-select v-model="addForm.buildingId" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in buildingList" :key="item.id" :label="item.buildingName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="面积" prop="area" class="formItem">
                <el-input-number v-model="addForm.area" clearable placeholder="请输入" style="width:80%;text-align: left;"
                  :min="0" :precision="2" :controls="false">
                </el-input-number> 平方米
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="承租状态" prop="rentType" class="formItem">
                <el-select v-model="addForm.rentType" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in rentTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="承租企业" prop="" class="formItem">
                <el-select v-model="addForm.rentCompanyId" placeholder="请选择" style="width:100%"
                  :disabled="addForm.rentType === '待出租'" clearable>
                  <el-option v-for="item in baseRenterCompanyList" :key="item.renterId" :label="item.renterCompanyName"
                    :value="item.renterId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="承租日期" prop="rentStartDate" class="formItem">
                <el-date-picker v-model="addForm.rentStartDate" type="date" placeholder="选择日期"
                  :disabled="addForm.rentType === '待出租'" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="到期日期" prop="rentEndDate" class="formItem">
                <el-date-picker v-model="addForm.rentEndDate" style="width:100%" type="date" placeholder="选择日期"
                  :disabled="addForm.rentType === '待出租'" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="日租金" prop="rentFee" class="formItem">
                <el-input-number v-model="addForm.rentFee" clearable placeholder="请输入" style="text-align: left;"
                  :disabled="addForm.rentType === '待出租'" :min="0" :precision="2" :controls="false">
                </el-input-number>元/平米/日
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物业费单价" prop="managementFee" class="formItem">
                <el-input-number v-model="addForm.managementFee" clearable placeholder="请输入"
                  :disabled="addForm.rentType === '待出租'" style="width:90%;text-align: left;" :min="0" :precision="2"
                  :controls="false">
                </el-input-number>元
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否已交租" prop="officeAreaNoRented" class="formItem">
                <el-select v-model="addForm.hasPayed" placeholder="请选择" style="width:100%"
                  :disabled="addForm.rentType === '待出租'">
                  <el-option v-for="item in isHasPayed" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="房屋照片" class="formItem" v-if="addForm.rentType === '已出租'">
            <uploadImg @handleFileImg="handleFileImg" :attachmentUrlList='addForm.attachmentUrl'></uploadImg>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeData">取 消</el-button>
          <el-button type="primary" @click="addEventForm()">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import uploadImg from '@/components/upload/uploadImg'
import { baseParkInfo, queryBuilding, baseRenterCompany, baseRoomInfo } from '@/api/basicInfo'
export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    page: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: 'rent'
    }
  },
  data () {
    return {
      columnDefs: [
        { label: '申请类型', prop: 'type' },
        { label: '申请人', prop: 'applyUser' },
        { label: '下一级审核人', prop: 'auditPerson' },
        {
          prop: 'status',
                    label: '申请状态',
                    formatter: (row, column, v) => {
                        return (this.statusOptions.find(v => v.value === row.status)).label
                    }
        },
        { label: '创建时间', prop: 'createTime' },
        { label: '操作', prop: 'action' }
      ],
      statusOptions: [
                {
                    label: '待审核',
                    value: 0
                },
                {
                    label: '已通过',
                    value: 1
                },
                {
                    label: '已拒绝',
                    value: 2
                },
            ],
      dialogFormVisible: false,
      addForm: {
        roomName: '', // 室号
        parkCode: '', // 所属园区
        buildingId: '', // 所属楼宇
        area: '', // 面积
        rentType: '', // 承租状态
        rentCompanyId: '', // 承租公司id
        rentCompanyName: '', // 承租公司名称
        rentStartDate: '', // 承租日期
        rentEndDate: '', // 到期日期
        rentFee: '', // 日租金
        managementFee: '', // 物业费单价
        hasPayed: '', // 是否已交租
        attachmentUrl: '', // 房屋照片
      },
      rules: {
        roomName: [{ required: true, message: '请填写', trigger: 'blur' }],
        buildingId: [{ required: true, message: '请选择', trigger: 'blur' }],
        parkCode: [{ required: true, message: '请选择', trigger: 'blur' }],
        area: [{ required: true, message: '请填写', trigger: 'blur' }],
        rentType: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      basePackInfoList: [],
      buildingList: [],
      baseRenterCompanyList: [],
      rentTypeOptions: [
        {
          label: '待出租',
          value: '待出租'
        },
        {
          label: '已出租',
          value: '已出租'
        },
      ],
      isHasPayed: [
        {
          label: '已交租',
          value: true
        },
        {
          label: '未交租',
          value: false
        },
      ]
    }
  },
  components: {
    TableList,
    uploadImg
  },
  methods: {
    pageChange (page) {
      this.$emit('pageChange', page, this.type)
    },
    viewOrHandle (row) {
      this.eventControl = '编辑房屋'
      switch (row.type) {
        case '证件申请':
          this.$router.push({
            path: '/comprehensive/certificates/record',
          })
          break;
        case '考勤异常申请':
          this.$router.push({
            path: '/comprehensive/checkWork/auditList',
          })
          break;
        case '用章申请':
          this.$router.push({
            path: '/comprehensive/sealManagement',
          })
          break;
        case '报销申请':
          this.$router.push({
            path: '/comprehensive/reimbursement/reimbursementDetailed',
          })
          break;
        case '用车申请':
          this.$router.push({
            path: '/comprehensive/carManagement/carApplication',
          })
          break;
        case '加班申请':
          this.$router.push({
            path: '/comprehensive/checkWork/myOverTime',
          })
          break;
        case '请假申请':
          this.$router.push({
            path: '/comprehensive/checkWork/leaveTimeDetailed',
          })
          break;
        case '通用申请':
          this.$router.push({
            path: '/comprehensive/commonApproval',
          })
          break;
        case '资产领用申请':
          this.$router.push({
            path: '/comprehensive/assetsManagement/assetsclaim',
          })
          break;
        case '资产采购申请':
          this.$router.push({
            path: '/comprehensive/assetsManagement/assetPurchase',
          })
          break;
        case '经联社信息登记审核申请':
          this.$router.push({
            path: '/community/Information',
          })
          break;
      
        default:
          break;
      }
      // console.log(row);
      // this.newOldFormContrast(row)
      // this.dialogFormVisible = true
    },
    newOldFormContrast(newForm) {
      Object.keys(this.addForm).forEach(key => {
        this.addForm[key] = newForm[key]
      })
      this.handleParkCode(newForm.parkCode)
      this.addForm.id = newForm.id
    },
    closeData() {
      this.dialogFormVisible = false
      this.$refs['addForm'].resetFields()
      this.addForm = this.$options.data.call(this).addForm
    },
    async baseParkList() {
      const { result } = await baseParkInfo('query', {
        pageNum: 1,
        pageSize: 10
      })
      this.basePackInfoList = result.records
    },
    async handleParkCode(val) {
      const { result } = await queryBuilding({
        parkCode: val,
        pageNum: 1,
        pageSize: 999
      })
      this.buildingList = result.records
    },
    handleAddParkCode(val) {
      this.handleParkCode(val)
      this.addForm.buildingId = ''
    },
    async baseRenterList() {
      const { result } = await baseRenterCompany('query', {
        pageNum: 1,
        pageSize: 999
      })
      this.baseRenterCompanyList = result.records
    },
    handleFileImg(imgs) {
      let arrUrl = imgs.map(v => v.code)
      this.addForm.attachmentUrl = arrUrl.join(',')
    },
    addEventForm() {
      this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          let res = await baseRoomInfo('update', this.addForm)
          if (res.code === 0) {
            this.$message.success('编辑成功！')
            this.closeData()
            this.$emit('query')
            this.pageChange(1)
          } else {
            this.$message.warning({ message: res.message })
          }
        }
      })
    }
  },
  mounted () {
    this.baseParkList()
    this.baseRenterList()
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  min-width: 750px;
  width: 50% !important;
}
</style>
